import { createActions } from 'redux-actions';

export default createActions({
  APPEND: ({ type, args }) => ({ type, args }),
});



// WEBPACK FOOTER //
// ./src/state/actions/nativeLogging.js